// Single Hub listener for Amplify auth failure events. Registered once at app
// startup from src/index.tsx. We only care about terminal failures here —
// successful sign-in / refresh are silent (the existing AppContent flow picks
// them up via fetchMetaDetails the first time an authed request goes out).

import { Hub } from "aws-amplify/utils";
import { signOut } from "aws-amplify/auth";
import { environment } from "src/config/environment";

let isRegistered = false;

const buildLoginUrl = (): string => {
	const basePath = (environment.REACT_APP_BASE_PATH || "").replace(/\/$/, "");
	return `${basePath}/login`;
};

const redirectToLogin = (): void => {
	if (typeof window === "undefined") return;
	const loginUrl = buildLoginUrl();
	if (!window.location.pathname.endsWith("/login")) {
		window.location.href = loginUrl;
	}
};

export const registerCognitoHubListener = (): void => {
	if (isRegistered) return;
	isRegistered = true;

	Hub.listen("auth", ({ payload }) => {
		switch (payload.event) {
			case "signInWithRedirect_failure":
				console.error("Cognito sign-in failed:", payload.data);
				redirectToLogin();
				break;
			case "tokenRefresh_failure":
				console.error("Cognito token refresh failed — both access and refresh tokens are likely expired/revoked.");
				signOut({ global: false }).finally(() => redirectToLogin());
				break;
			default:
				break;
		}
	});
};
